import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import HomePage from '../../Components/HomePage';
import PlayPage from '../../Components/PlayPage';
import SavedPage from '../../Components/SavedPage/SavedPage';
import AboutPage from '../../Components/AboutPage';

import NavBar from '../../Components/nav/NavBar';
// import { Container } from 'semantic-ui-react';
import TestComponent from '../../Components/testarea/TestComponent'
import ModalManager from '../../Components/modals/ModalManager';
import '../../App.scss';
import ReduxToastr from 'react-redux-toastr';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import { UserIsAuthenticated } from '../../Components/auth/authWrapper';
import Footer from '../../Components/footer/Footer';

class App extends Component {
  render() {
    return (
      <div className="App">
        <ReduxToastr
          position='bottom-right'
          transitionIn='fadeIn'
          transitionOut='fadeOut'
        />
        <ModalManager />
        <NavBar />
        <Switch>
          <Route exact path='/' component={HomePage} />
          <Route path='/play' component={PlayPage} />
          <Route path='/saved' component={SavedPage} />
          <Route path='/about' component={AboutPage} />

          <Route path='/test' component={TestComponent} />

        </Switch>
        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/app/layout/App.jsx